const networks = {
    public: 'public',
    test: 'test',
    local: 'local',
}

const hostnameToNetworkType = hostname => {
    if (hostname === `${window._env_.MAINNET_EXPANSION_ENDPOINT}` || hostname === 'publicnet.local')
        return networks.public
    else if (hostname === 'bantu.network.com' || hostname === 'testnet.local')
        return networks.test
    else return networks.test
}

export { networks as default, hostnameToNetworkType }



// WEBPACK FOOTER //
// ./src/lib/stellar/networks.js